<template>
    <div :ref="stepName" style="position:relative">
        <!--<div class="form-header">-->
        <!--</div>-->
        <EmailForm></EmailForm>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import EmailForm from "./EmailForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: {EmailForm},
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
